<template>

	<div class="form-group" :class="{ 'has-error': errors.has('class-level') }">

		<label for="class-level" class="control-label">{{ label }}</label>

		<select id="class-level" name="class-level" class="form-control" v-model="classLevelModel" v-validate="{ 'required': required }" :required="required"  @change="changed">
			<option value="" v-translate>Selecione</option>
			<option v-for="(option, index) in schoolClassLevels" :value="index">{{ option }}</option>
		</select>

	</div>

</template>

<script>

	import ClassLevel from './';
	export default ClassLevel;

</script>




// WEBPACK FOOTER //
// main.vue?fb8cb0dc